import formatNumber from 'helpers/formatNumber';
import { ReactComponent as FacebookIcon } from 'icons/socialWhite/facebook.svg';
import { ReactComponent as InstagramIcon } from 'icons/socialWhite/instagram.svg';
import { ReactComponent as TwitterIcon } from 'icons/socialWhite/twitter.svg';
import { ReactComponent as SpotifyIcon } from 'icons/socialWhite/spotify.svg';
import { ReactComponent as YouTubeIcon } from 'icons/socialWhite/youtube.svg';
import { ReactComponent as TikTokIcon } from 'icons/socialWhite/tiktok.svg';

export const platforms = [
  {
    platformName: 'YouTube',
    icon: YouTubeIcon,
    color: '#FF0000',
    id: 193,
  },
  {
    platformName: 'Twitter',
    icon: TwitterIcon,
    color: '#2AA9E0',
    id: 34,
  },
  {
    platformName: 'Facebook',
    icon: FacebookIcon,
    color: '#3B5998',
    id: 32,
  },
  {
    platformName: 'Spotify',
    icon: SpotifyIcon,
    color: '#1ED760',
    id: 192,
  },
  {
    platformName: 'Instagram',
    icon: InstagramIcon,
    color: '#BC3081',
    id: 33,
  },
];

const allPlatforms = [
  ...platforms,
  {
    platformName: 'TikTok',
    icon: TikTokIcon,
    id: 2041,
  },
];

const sortSocialMetrics = (socialMetrics: any): any => {
  const sortedSocialMetrics = allPlatforms.map((element) => {
    if (socialMetrics) {
      const social = socialMetrics[0]?.data?.find(
        (el: any) => el.platformName === element.platformName
      );
      const value = formatNumber(social?.countRtd, 'number', true);
      return {
        ...element,
        socialTitle: `${
          social?.platformName === 'YouTube' ? 'subscribers' : 'followers'
        }`,
        rawValue: social?.countRtd,
        value,
      };
    }
    return null;
  });

  return sortedSocialMetrics;
};

export default sortSocialMetrics;
